import toast from "react-hot-toast";
import ProductImage from "../../common/ProductImage";
import EditButton from "../../common/EditButton";
import ViewButton from "../../common/ViewButton";
import DeleteButton from "../../common/DeleteButton";
import { Form } from "react-bootstrap";
import CheckPermission from "../../roles/CheckPermission";
import { privateApi } from "../../../api";

const ServiceListBox = ({
      loading,
      services,
      loadData,
      setServices,
      setLoading,
}) => {
      const handleStatus = async (service) => {
            await privateApi
                  .post(`/dashboard/services/${service.slug}/status`)
                  .then((response) => {
                        if (response.data.result === "success") {
                              toast.success(response.data.message);
                        }
                        if (response.data.result === "error") {
                              toast.error(response.data.message);
                        }
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
      };

      const handleDelete = async (service) => {
            const response = await privateApi
                  .delete(`/dashboard/services/${service.slug}`)
                  .then((response) => {
                        if (response.data.result === "success") {
                              setServices((services) =>
                                    services.filter(
                                          (item) => item.id !== service.id
                                    )
                              );
                              loadData();
                              toast.success(response.data.message);
                              return true;
                        }
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
            return response;
      };

      return (
            <>
                  <thead>
                        <tr>
                              <th>#</th>
                              <th>Title</th>
                              <th width="80px">Status</th>
                              <th width="120px">Action</th>
                        </tr>
                  </thead>

                  <tbody>
                        {!loading ? (
                              services?.length > 0 ? (
                                    services?.map((service, index) => (
                                          <>
                                                <tr key={index}>
                                                      <td>{service.index}</td>
                                                      <td>
                                                            <ProductImage
                                                                  title={
                                                                        service.title
                                                                  }
                                                                  image={
                                                                        service.image
                                                                  }
                                                            />
                                                      </td>
                                                      <td className="text-center">
                                                            <Form.Check
                                                                  type="switch"
                                                                  defaultChecked={
                                                                        service.status ===
                                                                        1
                                                                              ? true
                                                                              : false
                                                                  }
                                                                  onClick={() =>
                                                                        handleStatus(
                                                                              service
                                                                        )
                                                                  }
                                                            />
                                                      </td>
                                                      <td className="text-center">
                                                            <EditButton
                                                                  link={`/dashboard/services/${service.slug}/edit`}
                                                            />
                                                            <ViewButton
                                                                  link={`/dashboard/services/${service.slug}/show`}
                                                            />
                                                            <CheckPermission permission="service-delete">
                                                                  <DeleteButton
                                                                        item={
                                                                              service
                                                                        }
                                                                        loading={
                                                                              loading
                                                                        }
                                                                        setLoading={
                                                                              setLoading
                                                                        }
                                                                        handleDelete={
                                                                              handleDelete
                                                                        }
                                                                  />
                                                            </CheckPermission>
                                                      </td>
                                                </tr>
                                          </>
                                    ))
                              ) : (
                                    <>
                                          <tr>
                                                <td
                                                      colSpan={8}
                                                      className="text-center"
                                                >
                                                      No Service Found
                                                </td>
                                          </tr>
                                    </>
                              )
                        ) : (
                              <>
                                    <tr>
                                          <td
                                                colSpan={8}
                                                className="text-center"
                                          >
                                                Loading...
                                          </td>
                                    </tr>
                              </>
                        )}
                  </tbody>
            </>
      );
};

export default ServiceListBox;
